import { styled } from 'styled-components';
import { theme } from '../../templates/ui';

export const Wrapper = styled.div`
  max-width: 768px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 ${theme.sizing.xlarge};
`;
